import { typeCheckAppModule } from "src/utils";
import { BulkEdit } from "./BulkEdit";
import { NAME } from "./constants";

export const bulkEdit = typeCheckAppModule({
    NAME,
    Container: BulkEdit,
});
